import { useState } from "react";
import { Button } from "react-bootstrap";
import ProfileCard from "./ProfileCard";

const ProfileExperienceSection = ({
  experiences,
  hasExperience,
  onAdd,
  onEdit,
  updateProfileSection,
  readOnly,
}) => {
  const [editing, setEditing] = useState(false);

  const saveExperience = async () => {
    await updateProfileSection({
      experiences: experiences,
    });
    setEditing(false);
  };

  const cancelExperience = () => {
    setEditing(false);
  };

  const currentExperience = hasExperience ? experiences[0] : null;

  return (
    <ProfileCard
      title="Experience"
      isEditing={editing}
      onEdit={() => {
        if (!hasExperience) {
          onAdd();
        } else {
          onEdit(0);
        }
      }}
      onSave={saveExperience}
      onCancel={cancelExperience}
      readOnly={readOnly}
    >
      {/* empty  state */}
      {!hasExperience && !editing && (
        <div className="experience-empty-state">
          <p>This section is empty</p>
          <span>Add your current experience</span>
          <Button className="cta-button mt-3 " onClick={onAdd}>
            Create
          </Button>
        </div>
      )}

      {/* experience display */}
      {hasExperience && currentExperience && (
        <div className="field-block experience-item d-flex justify-content-between">
          <div className="experience-main">
            <p>
              <strong>Company Name:</strong> {currentExperience.companyName}
            </p>
            <p>
              <strong>Position:</strong> {currentExperience.jobTitle}
            </p>

            {(currentExperience.startDate || currentExperience.endDate) && (
              <p>
                <strong>Duration:</strong>{" "}
                {currentExperience.startDate?.split("T")[0]} –{" "}
                {currentExperience.currentlyWorking
                  ? "Present"
                  : currentExperience.endDate?.split("T")[0] || "—"}
              </p>
            )}
          </div>
        </div>
      )}
    </ProfileCard>
  );
};

export default ProfileExperienceSection;
